var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<order-container type=\"list\" customer=\"$ctrl.customer\" customer-id=\"{{$ctrl.customer.id}}\" enable-query-string=\"true\" detail-route=\"orders.detail.lines\" hide-header=\"true\"></order-container>";
var id1="cust-details.orders.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;